function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import '../../helpers/polyfills/closest';

var AccordionItem = function AccordionItem(_ref) {
  var active = _ref.active,
      className = _ref.className,
      children = _ref.children,
      defaultActive = _ref.defaultActive,
      id = _ref.id,
      onClick = _ref.onClick,
      others = _objectWithoutProperties(_ref, ["active", "className", "children", "defaultActive", "id", "onClick"]);

  var ref = useRef();

  var _useState = useState(defaultActive),
      _useState2 = _slicedToArray(_useState, 2),
      _active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      expandedHeight = _useState4[0],
      setExpandedHeight = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      collapsedHeight = _useState6[0],
      setCollapsedHeight = _useState6[1];

  var isActive = typeof active !== 'undefined' ? active : _active; // Faire à l'avance un pré-calcul de la hauteur de l'accordéon plié et déplié,
  // Ces infos sont enregistrées dans les data-attributs "data-collapsed" et "data-expanded".
  // Nécessaire quand l'accordion est consommé par un parent où un traitement supplémentaire
  // est requis comme un scrollTo par exemple. Dans ce cas là on transmet au component react
  // un événement onClick qui initie le scrollTo en amont de déclencher le toggle.
  // C'est-à-dire avant que l'accordion a été rendu dans son état déplié.

  useEffect(function () {
    var e = ref.current;
    if (!e) return;
    var floor = Math.floor,
        abs = Math.abs;
    var expandedInactive = floor(abs(e.clientHeight + e.children[1].firstChild.clientHeight)).toString();
    var expandedActive = floor(abs(e.clientHeight)).toString();
    var collapsedInactive = floor(abs(e.clientHeight + 1)).toString();
    var collapsedActive = floor(abs(e.children[0].clientHeight)).toString();
    setExpandedHeight(isActive ? expandedActive : expandedInactive);
    setCollapsedHeight(isActive ? collapsedActive : collapsedInactive);
  }, [isActive]);

  var toggleAccordion = function toggleAccordion(e) {
    if (e.target.closest('.is-toggle-excluded') && !e.target.closest('.toggle')) {
      return false;
    }

    setActive(!_active);
    e.target.active = !_active;
    e.target.id = id;
    if (typeof onClick === 'function') onClick(e);
  };

  var classes = classNames('accordion', className, {
    'is-active': isActive
  });
  return React.createElement("article", _extends({
    className: classes
  }, {
    id: id,
    ref: ref
  }, others, {
    "data-collapsed": collapsedHeight,
    "data-expanded": expandedHeight
  }), children.map(function (child, index) {
    return React.cloneElement(child, {
      key: index,
      id: index === 0 ? "header-".concat(id) : "body-".concat(id),
      onClick: function onClick(e) {
        return index === 0 && toggleAccordion(e);
      }
    });
  }));
};

AccordionItem.propTypes = {
  id: PropTypes.string,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  defaultActive: PropTypes.bool,
  active: PropTypes.bool,
  onClick: PropTypes.func
};
AccordionItem.defaultProps = {
  id: (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase()
};
AccordionItem.displayName = 'Accordion.Item';
export default withModifiers(AccordionItem);